module.exports = __webpack_public_path__ + "static/img/hy_01.61cffdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hy_01.jpg
// module id = 2e4b
// module chunks = 0